<template>
	<div>内容待开发...</div>
</template>

<script>

export default {
  data() {
    return {
      
    }
  },
  methods: {
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// zuhuAllow.vue?0c3c26dc